import { Progress } from "@/components/ui/progress";
import {AutoTranslate} from "@/lib/autoTranslate.tsx";
import { useTranslation} from "react-i18next";
interface ProgressTrackerProps {
  progress: number;
}

export function ProgressTracker({ progress }: ProgressTrackerProps) {
  const transText = useTranslation().t('autoTranslate', { returnObjects: true });
  const { i18n } = useTranslation();


  return (
    <div className="p-3 bg-card/80 backdrop-blur-sm border-t border-border sm:p-4">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-foreground">{AutoTranslate(`Resume Progress`)}</span>
        <span className="text-sm text-muted-foreground">{progress}%</span>
      </div>
      <Progress value={progress} className="w-full" />
    </div>
  );
}
